import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StepActionService {

  addNextStep = new Subject<ActionContext>();
  editStep = new Subject<ActionContext>();
  deleteStep = new Subject<ActionContext>();
  
  constructor() { }

  triggerAdd(ctx: ActionContext) {
    this.addNextStep.next(ctx);
  }

  triggerEdit(ctx: ActionContext) {
    this.editStep.next(ctx);
  }

  triggerDelete(ctx: ActionContext) {
    this.deleteStep.next(ctx);
  }

}

export class ActionContext {  
  operation: ActionOperation;
  parent: any;    // the parent node  
  original: any;  // the original item that is edited
  edited: any;    // the modified item
}



export enum ActionOperation {
  Add = 'Add',
  Edit = 'Edit',
  Delete = 'Delete'
}


